"use client";
import React from "react";

export const LineChart = ({ data, width = 400, height = 200 }) => {
  const padding = 40;
  const chartWidth = width - padding * 2;
  const chartHeight = height - padding * 2;

  // Calculate points
  const xStep = chartWidth / (data.length - 1);
  const yMax = Math.max(...data);
  const yScale = chartHeight / yMax;

  // Generate path
  const points = data.map((value, index) => ({
    x: padding + index * xStep,
    y: height - padding - value * yScale,
  }));

  const pathD = points.reduce((path, point, index) => {
    return path + `${index === 0 ? "M" : "L"} ${point.x} ${point.y}`;
  }, "");

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <h3 className="text-gray-700 font-medium mb-4">Activity Trend</h3>
      <svg width={width} height={height} className="overflow-visible">
        {/* Y-axis */}
        <line
          x1={padding}
          y1={padding}
          x2={padding}
          y2={height - padding}
          stroke="#e5e7eb"
          strokeWidth="1"
        />
        {/* X-axis */}
        <line
          x1={padding}
          y1={height - padding}
          x2={width - padding}
          y2={height - padding}
          stroke="#e5e7eb"
          strokeWidth="1"
        />
        {/* Data line */}
        <path
          d={pathD}
          fill="none"
          stroke="#3b82f6"
          strokeWidth="2"
          className="transition-all duration-300"
        />
        {/* Data points */}
        {points.map((point, index) => (
          <circle
            key={index}
            cx={point.x}
            cy={point.y}
            r="4"
            fill="#3b82f6"
            className="transition-all duration-300 hover:r-6"
          />
        ))}
      </svg>
    </div>
  );
};
